import { render, staticRenderFns } from "./ForwardingItemMoreOptionsModal.vue?vue&type=template&id=0c63d63a&scoped=true"
import script from "./ForwardingItemMoreOptionsModal.vue?vue&type=script&lang=js"
export * from "./ForwardingItemMoreOptionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c63d63a",
  null
  
)

export default component.exports